export default "__VITE_ASSET__CyNVBxMB__"